const officeDto = {
  name: null,
  address: null,
  idClient: 0,
};

export default officeDto;
